"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeTextSearchOperatorTypeEnum = void 0;
exports.FreeTextSearchOperatorTypeEnum = {
    And: 'and',
    Or: 'or'
};
